"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamReactions = void 0;
exports.StreamReactions = [
    {
        id: 0,
        text: "💦"
    },
    {
        id: 1,
        text: "🔥"
    },
    {
        id: 2,
        text: "❤️"
    },
    {
        id: 3,
        text: "👍"
    },
    {
        id: 4,
        text: "😌"
    },
    {
        id: 5,
        text: "👏"
    },
    {
        id: 6,
        text: "🙏"
    },
    {
        id: 7,
        text: "💪"
    }
];
//# sourceMappingURL=Reactions.js.map